export default __webpack_public_path__ + "static/media/989.8c92fadf.png";